<template>
  <draggable-item-grid
    :items="items"
    :drag-bus="dragBus"
    :show-add-item-button="allowAddItems && allowEdit"
    :horizontal-align="'left'"
    :drag-mode="itemsDraggable && allowEdit ? 'drag' : null"
    :drop-mode="itemsDraggable && allowEdit ? 'insert' : null"
    :allow-drop-on-empty-slot="allowEdit"
    :drag-area-group="itemGroup"
    class="w-full"
    @itemdrop="onItemDropped"
    ><template v-slot:reference
      ><fleet-item-placeholder :item-width="itemWidth"/></template
    ><template v-slot:item="content"
      ><fleet-item
        :entry="content.entry"
        :draggable="content.draggable"
        :clone-on-drag="content.cloneOnDrag"
        :item-width="itemWidth"
        :simulation-bus="simulationBus"
        :item-type-selection-bus="itemTypeSelectionBus"
        :special-ship-bus="specialShipBus"
        :allow-edit-amount="allowEditAmounts"
        @pictureclick="onItemPictureClick(content.entry)"/></template
    ><template v-slot:placeholder="content"
      ><fleet-item-placeholder
        :item-width="itemWidth"
        v-show="content.entry == null"/></template
    ><template v-slot:additem
      ><fleet-item-placeholder
        :item-width="itemWidth"
        :interactable="true"
        @click="addItem"/></template
  ></draggable-item-grid>
</template>

<script>
import Vue from "vue";
import DraggableItemGrid from "@/components/draggable/DraggableItemGrid";
import FleetItemPlaceholder from "@/components/fleet/FleetItemPlaceholder";
import FleetItem from "@/components/fleet/FleetItem";

export default {
  name: "FleetItemList",
  components: {
    FleetItemPlaceholder,
    DraggableItemGrid,
    FleetItem
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    itemGroup: {
      type: String,
      default: null
    },
    dragBus: {
      type: Vue,
      required: true
    },
    simulationBus: {
      type: Vue,
      default: null
    },
    itemTypeSelectionBus: {
      type: Vue,
      default: null
    },
    specialShipBus: {
      type: Vue,
      default: null
    },
    itemWidth: {
      type: String,
      default: "10rem"
    },
    itemsDraggable: {
      type: Boolean,
      default: false
    },
    allowAddItems: {
      type: Boolean,
      default: true
    },
    allowEdit: {
      type: Boolean,
      default: true
    },
    allowEditAmounts: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    onItemDropped() {
      if (!this.allowEdit) {
        return;
      }
      this.$emit("change");
    },
    onItemPictureClick(entry) {
      if (!this.allowEdit) {
        return;
      }
      this.$emit("itempictureclick", entry);
    },
    addItem() {
      if (!this.allowEdit) {
        return;
      }
      this.$emit("additem");
    }
  }
};
</script>

<style scoped></style>
